import { createAddSyncSlice } from '@sonar-software/xuder';
import { getAdminFeatureFlagsSlice } from './get';
import { OverrideAdminFeatureFlagName } from './_id/customer/name';
import { PostOverrideAdminFeatureFlagByCustomerIdRequest } from '../../api';

export const addAdminFeatureFlagCustomerSlice = createAddSyncSlice({
	name: OverrideAdminFeatureFlagName,
	state: getAdminFeatureFlagsSlice.asyncState,
	transform: (action: PostOverrideAdminFeatureFlagByCustomerIdRequest, state) => ({
		featureFlags: state?.featureFlags?.map((flag) => {
			if (flag.name === action.featureFlag) {
				const index = flag.exceptionCustomers.findIndex((customer) => customer.id === action.customerId);

				if (index === -1) {
					return {
						...flag,
						exceptionCustomers: [
							...flag.exceptionCustomers,
							{
								enabled: action.enabled,
								id: action.customerId,
								name: action.customerName,
								shardName: action.shardName
							}
						]
					};
				}

				const target = flag.exceptionCustomers[ index ];

				return {
					...flag,
					exceptionCustomers: [
						...flag.exceptionCustomers.slice(0, index),
						{
							...target,
							enabled: action.enabled
						},
						...flag.exceptionCustomers.slice(index + 1)
					]
				};
			}

			return flag;
		}) ?? [],
		totalCustomerCount: state?.totalCustomerCount ?? 0
	})
});
